import {FC, ReactElement} from "react";
import useAuthStore from "../../../states/zustand/authStore";

type Props = {
    roles:string[],
    children?: ReactElement
}

const WithPermission: FC<Props> = ({children, roles}): JSX.Element => {
    const { role } = useAuthStore(state => state.profileData);
    return(
        <>
            {
                roles.includes(role) ? children : <> </>
            }
        </>
    )
}

export default WithPermission;